import CommonStatus from './CommonStatus';
import ProviderValidationModal from './ProviderValidationModal';

export default class Provider extends React.Component {
    constructor(props) { super(props); }

    componentDidUpdate(prev) {
        this.toggleView(prev);
    }

    toggleView = prev => {
        const
        { failureCallback } = this.props,
        pStatus = prev.status,
        cStatus = this.props.status;

        if (pStatus !== cStatus && cStatus === 409)
            if (failureCallback) failureCallback(cStatus);
    }

    render() {
        const { status, modalProps, custom } = this.props;
        switch(status) {
            case 'none': return <ProviderValidationModal status={status} data={custom} />;
            case 409: return <CommonStatus {...this.props} />;
            case 418: return <CommonStatus {...this.props} />
            default: return <CommonStatus {...this.props} />;
        }
    }
}